import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box, Card, Stack, Typography } from "@mui/material";
import ActionTrackerListPopUp from "./ActionTrackerListPopUp";

const ActionCategoryChart = ({ categoryWiseStats, columns }) => {

    const [isViewTracker, setIsViewTracker] = useState(false);
    const [rowData, setRowData] = useState(null);

    const categories = categoryWiseStats?.map(item => item?.category);
    const openData = categoryWiseStats?.map(item => item?.open);
    const closeData = categoryWiseStats?.map(item => item?.close);
    const hasData = categoryWiseStats?.length > 0

    const options = {
        chart: {
            type: "column",
            height: "70%",
            scrollablePlotArea: {
                minWidth: categories?.length * 90,  // 80px per category
                scrollPositionX: 0,
            },
            spacingBottom: 20,
        },
        legend: {
            enabled: true,
            align: "center",
            verticalAlign: "bottom",
            floating: false,
        },
        title: {
            text: "",
            style: {
                color: "#7E7E7E",
                fontWeight: '500',
                fontFamily: "Outfit"
            }
        },
        subtitle: {
            text: "",
        },
        xAxis: {
            // min: 0,
            // max: 4,                // show 5 categories at a time (0–4)
            // scrollbar: {
            //     enabled: false
            // },
            categories: categories,
            crosshair: true,
            accessibility: {
                description: "Countries",
            },
            labels: {
                useHTML: true,
                //rotation: -90,
                style: {
                    width: '80px',
                    whiteSpace: "normal",
                    textOverflow: 'unset'
                }
            }
        },
        yAxis: {
            min: 0,
            max: 40,
            startOnTick: false,
            endOnTick: false,
            tickAmount: 5,
            gridLineWidth: 0,
            title: {
                text: "",
            },
        },
        credits: { enabled: false },
        legend: { enabled: true },
        tooltip: {
            valueSuffix: "",
        },
        plotOptions: {
            column: {
                stacking: 'normal',
                borderWidth: 0,
                point: {
                    events: {
                        click: function () {
                            console.log("Clicked", this);

                            onBarClick(this);
                            // alert(
                            //     `Category: ${this.category}\n` +
                            //     `Series: ${this.series.name}\n` +
                            //     `Value: ${this.y}`
                            // );
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        fontWeight: '500',
                        fontFamily: "Outfit",
                        textOutline: 'none',
                        textShadow: 'none',
                        fontSize: '14px'
                    }
                }
            }
        },
        series: [
            {
                name: "Open",
                data: openData
            },
            {
                name: "Closed",
                data: closeData
            },
        ],
    };

    const onBarClick = (point) => {
        setIsViewTracker((prev) => {
            const newState = !prev;
            setRowData(newState ? { Topic: point?.category, Status: point?.series?.name } : null);
            return newState;
        });
    }

    const handleClose = () => {
        setIsViewTracker(false)
        setRowData(null)
    }
    return (
        <>
            <Card
                elevation={0}
                sx={{
                    borderRadius: "3px",
                    border: "1px solid #E4E4E4",
                    width: '100%',
                    minHeight: { xs: 340, md: 340, xl: "auto" },
                    maxHeight: { xs: 340, md: 340, xl: "none" },
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Box sx={{
                    width: '100%',
                    borderBottom: "1px solid #E4E4E4",
                    p: 1,
                    mb: 2,
                    display: 'flex',
                    justifyContent: 'space-between'
                }}>
                    <Box>
                        <Typography variant="subtitle1" sx={{
                            fontFamily: "Outfit, sans-serif",
                            fontWeight: 600,
                            fontSize: '20px',
                            letterSpacing: "0px",
                            mb: 0
                        }}>
                            Category Wise Stats
                        </Typography>
                        <Typography variant="subtitle1" sx={{
                            fontWeight: 500,
                            fontSize: '14px',
                            lineHeight: "140%",
                            color: "#7D7F81",
                            letterSpacing: "1%",
                            fontFamily: "Poppins, sans-serif",
                        }}>
                            Open and closed action items across all categories.
                        </Typography>
                    </Box>
                </Box>
                {hasData ?
                    <Box
                        sx={{
                            width: "100%",
                            overflowX: "auto",
                            overflowY: "hidden",
                        }}
                    >
                        <HighchartsReact highcharts={Highcharts} options={options} />
                    </Box>
                    : <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            pb: 2,
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: "Outfit, sans-serif",
                                fontSize: "16px",
                                fontWeight: 500,
                                color: "#9E9E9E",
                            }}
                        >
                            Data Not Available
                        </Typography>
                    </Box>}
            </Card>
            {isViewTracker &&
                <ActionTrackerListPopUp open={isViewTracker} data={rowData} handleClose={handleClose} columns={columns} />
            }
        </>
    );
};

export default ActionCategoryChart;
